/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
window.octicons = require("@primer/octicons");

// window.Vue = require('vue').default;
import { Vue, createApp } from 'vue'
import { createPinia } from 'pinia'
import { createWebHistory, createRouter, useRoute } from 'vue-router'
import Vue3Signature from "vue3-signature"

import routes from './Router/routes'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import BootstrapVue3 from 'bootstrap-vue-3'
import VueFeather from 'vue-feather';
import Vue3VideoPlayer from '@cloudgeek/vue3-video-player'

import PhoneInputComponent from './components/PhoneInputComponent'
import DisputeCenterComponent from './components/DisputeCenterComponent'
import DisputeCenterComponentDiy from './components/DisputeCenterComponentDiy'
import PersonalInformationComponent from './components/letters/PersonalInformationComponent.vue'
import FaxModalComponent from './components/FaxModalComponent'
import NotificationDropdown from './components/NotificationDropdown'
import CheckoutDropdown from './components/CheckoutDropdown'
import FooterComponent from './components/FooterComponent'
import PlansComponent from './components/PlansComponent'

// import VueGoodTableNextPlugin from 'vue-good-table-next';
import BureauLetter from './components/letters/BureauLetter'
import CreditorLetter from './components/letters/CreditorLetter'
import PublicRecordLetter from './components/letters/PublicRecordLetter'
import CreditorInquiryLetter from './components/letters/CreditorInquiryLetter'
import DataFurnisherLetter from './components/letters/DataFurnisherLetter'
import LexisNexisLetter from './components/letters/LexisNexisLetter'
import CraFtcComplaint from './components/letters/CraFtcComplaint'
import InquiryLetter from './components/letters/InquiryLetter'
import LexisNexisSecurityFreeze from './components/letters/LexisNexisSecurityFreeze'
import AccountResolutionServicesSecurityFreeze from './components/letters/AccountResolutionServicesSecurityFreeze'
import CorelogicCredcoSecurityFreeze from './components/letters/CorelogicCredcoSecurityFreeze'
import CraStudentLoanDispute from './components/letters/CraStudentLoanDispute'
import CreditorStudentLoanDispute from './components/letters/CreditorStudentLoanDispute'
import SagestreamSecurityFreeze from './components/letters/SagestreamSecurityFreeze'
import SagestreamRequestForDisclosure from './components/letters/SagestreamRequestForDisclosure'
import SagestreamRequestAnInvestigation from './components/letters/SagestreamRequestAnInvestigation'
import OptOutPreScreen from './components/letters/OptOutPreScreen'
import NctueSecurityFreeze from './components/letters/NctueSecurityFreeze'
import FactorTrustSecurityFreeze from './components/letters/FactorTrustSecurityFreeze'
import ChexsystemSecurityFreeze from './components/letters/ChexsystemSecurityFreeze'
import InnovisSecurityFreeze from './components/letters/InnovisSecurityFreeze'
import CraInitialDispute from './components/letters/CraInitialDispute'
import InitialValidationDispute from './components/letters/InitialValidationDispute'
import InitialVerificationDispute from './components/letters/InitialVerificationDispute'
import CollectionAgencyComputerResponse from './components/letters/CollectionAgencyComputerResponse'
import CollectionAgencyItemizedListResponse from './components/letters/CollectionAgencyItemizedListResponse'
import CollectionAgencyMoreInformationResponse from './components/letters/CollectionAgencyMoreInformationResponse'
import CollectionAgencyNoResponse from './components/letters/CollectionAgencyNoResponse'
import CreditorNoResponse from './components/letters/CreditorNoResponse'
import CreditorPartialVerificationResponse from './components/letters/CreditorPartialVerificationResponse'
import CreditorMoreInformationResponse from './components/letters/CreditorMoreInformationResponse'
import CraMethodOfVerificationResponse from './components/letters/CraMethodOfVerificationResponse'
import CraNoResponse from './components/letters/CraNoResponse'
import CraCollectionAgencyFailedToValidateResponse from './components/letters/CraCollectionAgencyFailedToValidateResponse'
import FactualDisputeLetter from './components/letters/FactualDisputeLetter'
import Metro2Letter1 from './components/letters/Metro2Letter1'
import Metro2Letter2 from './components/letters/Metro2Letter2'
import Metro2Letter3 from './components/letters/Metro2Letter3'
import CollectionAgencyEstoppelBySilence from './components/letters/CollectionAgencyEstoppelBySilence'
import CreditorStillNoResponse from './components/letters/CreditorStillNoResponse'
import CreditorPartialVerificationResponse2 from './components/letters/CreditorPartialVerificationResponse2'
import DebtVerifiedResponse from './components/letters/DebtVerifiedResponse'
import CreditorNoticeOfComplaint from './components/letters/CreditorNoticeOfComplaint'
import CaNoticeOfComplaint from './components/letters/CaNoticeOfComplaint'
import CraNoticeOfComplaint from './components/letters/CraNoticeOfComplaint'
import CraLatePaymentDispute from './components/letters/CraLatePaymentDispute'
import CreditorLatePaymentDispute from './components/letters/CreditorLatePaymentDispute'
import CeaseDesistLetter from './components/letters/CeaseDesistLetter'
import DebtValidationLetter from './components/letters/DebtValidationLetter'
import AffidavitOfTruthLetter from './components/letters/AffidavitOfTruthLetter'
import CreditorFtcComplaint from './components/letters/CreditorFtcComplaint'
import CaFtcComplaint from './components/letters/CaFtcComplaint'
import RequestForVerificationRound1 from './components/letters/RequestForVerificationRound1.vue'
import RequestForVerificationRound2 from './components/letters/RequestForVerificationRound2.vue'
import RequestForVerificationRound3 from './components/letters/RequestForVerificationRound3.vue'
import DemandForRemovalLetter from './components/letters/DemandForRemovalLetter.vue'
import ReinsertionDisputeLetter from './components/letters/ReinsertionDisputeLetter.vue'
import RequestToRemoveFraudAlert from './components/letters/RequestToRemoveFraudAlert.vue'
import MethodOfVerificationLetter from './components/letters/MethodOfVerificationLetter.vue'
import NotificationOfLawsuitLetter from './components/letters/NotificationOfLawsuitLetter.vue'
import FailureToRespondWithin15Days from './components/letters/FailureToRespondWithin15Days.vue'
import FailureToRespondWithin30Days from './components/letters/FailureToRespondWithin30Days.vue'
import FailedToMarkNoticeOfDispute from './components/letters/FailedToMarkNoticeOfDispute.vue'
import StallLetterResponse from './components/letters/StallLetterResponse.vue'
import RequestingTheRemovalOfInaccurateInformation from './components/letters/RequestingTheRemovalOfInaccurateInformation.vue'
import RequestingTheRemovalOfInaccurateAccountsRound2 from './components/letters/RequestingTheRemovalOfInaccurateAccountsRound2.vue'
import RequestingTheRemovalOfInaccurateAccountsRound3 from './components/letters/RequestingTheRemovalOfInaccurateAccountsRound3.vue'
import IntentToFileSuitViolationOfTheFcra from './components/letters/IntentToFileSuitViolationOfTheFcra.vue'
import CollectionDisputeLetter1B from './components/letters/CollectionDisputeLetter1B.vue'
import CollectionDisputeLetter2 from './components/letters/CollectionDisputeLetter2.vue'
import CollectionDisputeLetter3 from './components/letters/CollectionDisputeLetter3.vue'
import CollectionDisputeLetter4 from './components/letters/CollectionDisputeLetter4.vue'
import LatePaymentDisputeLetter1 from './components/letters/LatePaymentDisputeLetter1.vue'
import LatePaymentDisputeLetter2 from './components/letters/LatePaymentDisputeLetter2.vue'
import LatePaymentDisputeLetter3 from './components/letters/LatePaymentDisputeLetter3.vue'
import LatePaymentDisputeLetter4 from './components/letters/LatePaymentDisputeLetter4.vue'
import RepossessionLetter1 from './components/letters/RepossessionLetter1.vue'

import LobLetter from './components/LobLetter'
import AuthorizedUser from './components/AuthorizedUser'
import AuthorizedUserCheckout from './components/AuthorizedUserCheckout'
import CraBankruptcyValidationLetter from './components/letters/CraBankruptcyValidationLetter'
import CraBankruptcyResponseLetter from './components/letters/CraBankruptcyResponseLetter'
import CraBankruptcyMetro2Letter from './components/letters/CraBankruptcyMetro2Letter'
import LexisnexisBankruptcyValidationLetter from './components/letters/LexisnexisBankruptcyValidationLetter'
import LexisnexisBankruptcyResponseLetter from './components/letters/LexisnexisBankruptcyResponseLetter'
import LexisnexisCreditFreezeRequest from './components/letters/LexisnexisCreditFreezeRequest'
import CustomLetter from './components/letters/CustomLetter'
import CreditorCarRepossessionLetter1 from './components/letters/CreditorCarRepossessionLetter1'
import CreditorCarRepossessionLetter2 from './components/letters/CreditorCarRepossessionLetter2'
import MedicalCollectionLawLetter from './components/letters/MedicalCollectionLawLetter'
import CourthouseLetter from './components/letters/CourthouseLetter'
import CreditBureauMedicalLetter from './components/letters/CreditBureauMedicalLetter'
import DemandToComplyLawLetter from './components/letters/DemandToComplyLawLetter'
import PermissblePurposeLawLetter from './components/letters/PermissblePurposeLawLetter'
import AuthorBlogComponent from './components/blogs/authors/AuthorBlogComponent.vue'
import LetterEdit from './components/letters/Edit'
import BlogComponent from './components/blogs/BlogComponent.vue'
import CreateComponent from './components/blogs/CreateBlogComponent.vue'
import BlogContentComponent from './components/blogs/BlogContentComponent.vue'
import BlogEditComponent from './components/blogs/BlogEditComponent.vue'

import AdminDashboard from './components/admin_dashboard/IndexComponent.vue'
import AdminUserView from './components/admin_dashboard/admin_user_view/AdminUserView.vue'
import IndexComponent from './components/profile/IndexComponent.vue'
import BusinessUserAccount from './components/profile/BusinessUserAccount.vue'
import CustomLetterCreateComponent from './components/CustomLetterCreateComponent.vue'
import Pagination from 'v-pagination-3';
import titlemixin from './@core/mixins/titlemixin';
import { useLocalizationStore } from './stores/LocalizationStore.js'
import { useStateStore } from './stores/StateStore.js'
import { usePlanStore } from './stores/PlanStore.js'
import { useUserStore } from './stores/UserStore.js'
import { useLetterStore } from './stores/LetterStore.js'
import { useDisputeLetterStore } from './stores/DisputeLetterStore.js'
import SpinnerComponent from './components/SpinnerComponent.vue'
import RoleComponent from './components/rbac/RolesComponent'
import PermissionsComponent from './components/rbac/PermissionsComponent'
import OtpVerifyComponent from './components/auth/OtpVerifyComponent.vue'
import AddPhoneComponent from './components/profile/layout/component/AddPhoneComponent.vue'
import CreditScores from './components/report/CreditScores.vue'
import ReportSummaryComponent from './components/report/Summary.vue'
import AccountHistoryComponent from './components/report/AccountHistory.vue'
import PaymentHistoryComponent from './components/report/PaymentHistory.vue'
import DeletedAccountDetailComponent from './components/report/DeletedAccountDetail.vue'
import DerogatoryComponent from './components/report/Derogatory.vue'
import LatePaymentComponent from './components/report/LatePayment.vue'
import InquiryComponent from './components/report/Inquiry.vue'
import PublicRecordComponent from './components/report/PublicRecord.vue'
import ReportComponent from './components/report/Report.vue'
import CreditAnalysis from './components/report/CreditAnalysis.vue'
import AccountDetailModalComponent from './components/report/modals/AccountDetail.vue'
import CreditMonitoring from "./components/report/CreditMonitoring.vue"
import AttackHistoryComponent from './components/dispute/AttackHistory.vue'
import DisputeReportComponent from './components/dispute/Report.vue'
import IdentityIQComponent from './components/report/form/IdentityIQComponent.vue'
import EmailComponent from './components/modals/Email.vue'
import FaxHistory from './components/clicksend/FaxHistory'
import TimelineComponent from './components/user/TimelineComponent.vue'
import EmailHistory from './components/clicksend/EmailHistory'
import KnowledgeBaseComponent from './components/knowledge_base/KnowledgeBaseComponent'
import KnowledgeBaseVideo from './components/knowledge_base/KnowledgeBaseVideo'
import CreateKnowledgeBaseVideos from './components/knowledge_base/admin_view/CreateKnowledgeBaseVideos'
import CreateCategoryKnowledgeBase from './components/knowledge_base/admin_view/CreateCategoryKnowledgeBase'
import FilterComponent from './components/FilterComponent'
import OrderHistory from './components/OrderHistory.vue'
import AdminOrderHistory from './components/AdminOrderHistory.vue'
import VueSignature from "vue-signature-pad";
import BillingComponent from './components/billing/BillingComponent'
import FamilyDashboard from './components/family/FamilyDashboard'
import DiyDashboardHeader from './components/panels/navbar/DiyDashboardHeader'
import BusinessHeader from './components/panels/navbar/BusinessHeader'
import TeamHeader from './components/panels/navbar/TeamHeader'
import ViewLetterContentComponent from './components/letter_content/ViewComponent'
import CreateLetterContentComponent from './components/letter_content/CreateComponent'
import EditLetterContentComponent from './components/letter_content/EditComponent'
import IndexLetterContentComponent from './components/letter_content/IndexComponent'
import CertifiedMailerModal from './components/dispute_letter/CertifiedMailerModal.vue'
import DisputeTrackerComponent from './components/dispute_letter/DisputeLetterComponent.vue'
import InvoiceIndexComponent from './components/invoice/IndexComponent.vue'
import InvoiceTabComponent from './components/invoice/TabComponent.vue'
import ImportClientModal from './components/modals/ImportClientModal.vue'
import IndexDashboard from './components/dashboard/IndexComponent.vue'
import LincenceStateId from './components/dashboard/DiyComponents/PersonalInfo/LincenceStateId.vue'
import SocialSecurityCardUpload from './components/dashboard/DiyComponents/PersonalInfo/SocialSecurityCardUpload.vue'
import AddressVerificationUpload from './components/dashboard/DiyComponents/PersonalInfo/AddressVerificationUpload.vue'
import UploadIdTheftAffidavit from './components/dashboard/DiyComponents/PersonalInfo/UploadIdTheftAffidavit.vue'



import PersonalInfoModal from './components/dashboard/DiyComponents/PersonalInfo/PersonalInfoModal.vue'
import MyScoreIQReport from './components/dashboard/DiyComponents/CreditMonitoringServices/MyScoreIQReport.vue'

import SmartCreditReport from './components/dashboard/DiyComponents/CreditMonitoringServices/SmartCreditReport.vue'
import MyFreeScoreNowForm from './components/dashboard/DiyComponents/CreditMonitoringServices/MyFreeScoreNowForm.vue'
import ProofIdentityDocument from './components/dashboard/DiyComponents/PersonalInfo/ProofIdentityDocument.vue'

import DisputeLetterTracker from './components/dispute_letter/DisputeLetterTracker.vue'
import CreditAnalysisModal from './components/dashboard/DiyComponents/CreditAnalysisModal.vue'

import LobSetting from './components/settings/Lob.vue'
import FaxSetting from './components/settings/Fax.vue'
import AdminSetting from './components/settings/Admin.vue'
import CreditContactIndexComponent from './components/credit_contact/IndexComponent.vue'
import CreditContactTabComponent from './components/credit_contact/TabComponent.vue'
import LetterDocumentUpload from './components/modals/LetterDocumentUpload.vue'

import Ssn from './components/modals/Ssn.vue'
import Profile from './components/user/Profile.vue'
import DisputeCount from "./components/dispute/Count.vue"
import ThirtyDayReport from './components/report/ThirtyDayReport.vue'
import ClientDetail from './components/ClientDetail.vue'
import ClientReportForm from './components/ClientReportForm.vue'

import LetterTutorial from './components/letters/components/LetterTutorial'
import LetterVideo from './components/letters/components/LetterVideo'

import HomeComponent from './components/HomeComponent'
import EditPipelineClient from './components/business/opportunities/pipeline/modal/components/EditPipelineClient.vue'
import PipelineActivity from './components/business/opportunities/pipeline/modal/components/PipelineActivity.vue'
import DisputeActivity from './components/business/opportunities/pipeline/modal/components/DisputeActivity.vue'

import CropImageModel from './components/dashboard/DiyComponents/PersonalInfo/CropImageModel.vue'
import ContractInfoComponent from './components/client/ContractInfoComponent.vue'

import GohighlevelComponent from './components/gohighlevel/GohighlevelComponent.vue'
import GenerateAccessToken from './components/gohighlevel/GenerateAccessToken.vue'
import ReferralsComponent from './components/referrals/ReferralsComponent.vue'
import EbookComponent from './components/Home/Landing/EbookComponent'
import UserEbookProducts from './components/Home/Landing/UserEbookProducts'
import MessagesComponent from './components/messages/MessagesComponent.vue'
import MessagesModel from './components/messages/MessageModel.vue'
import NavbarComponent from './components/client/panel/NavbarComponent.vue'
import VideoPlayerModel from "./components/dashboard/DiyComponents/VideoModal/VideoPlayerModel.vue"
import ContractDownloadComponent from "./components/user/ContractDownloadComponent.vue"
import DataFurnisherModal from './components/modals/DataFurnisherModal.vue'
import ImageCropperModal from './components/Education/modals/ImageCropperModal.vue'
import StarRating from './components/star_rating/StarRating.vue'
import HomeNavComponent from './components/blogs/NavComponent.vue'
const app = createApp({
    setup: () => {
        const route = useRoute();
        if (!_.includes(['landing-page','e-book','login', 'register', 'client-login', 'blogs', 'courses-guest','courses-content-guest','blog-category-content','black-friday-landing'], route.name)) {
            if (
                _.isNull(usePlanStore().plans) || _.isNull(usePlanStore().coursesPlans)
                &&
                !_.includes(['client-plans', 'client-dashboard'], route.name)
            ) {
                usePlanStore().fetchPlans();
                usePlanStore().fetchCoursesPlans();
            }
            if (_.isNull(useLetterStore().letters)) {
                useLetterStore().fetchLetters();
            }
            useLocalizationStore().getLanguage();
            useUserStore().fetchUser();
            useDisputeLetterStore().fetchCreditors();
            useUserStore().fetchUserProfile();
        }
        if (_.includes(['blogs', 'blog-category-content'], route.name)) {
            useUserStore().fetchUser();
        }
        if (!_.includes(['login', 'client-login'], route.name)) {
            if (_.isNull(useStateStore().states)) {
                useStateStore().fetchState();
            }
        }

    }
})
const pinia = createPinia()
app.use(VueSignature);
// app.config.productionTip = false;
pinia.use(piniaPluginPersistedstate)

app.component('phone-input-component', PhoneInputComponent)
app.component('dispute-center-component', DisputeCenterComponent)
app.component('dispute-center-component-diy', DisputeCenterComponentDiy)
app.component('personal-information-component', PersonalInformationComponent)
app.component('fax-modal-component', FaxModalComponent)
app.component('notification-dropdown', NotificationDropdown)
app.component('checkout-dropdown', CheckoutDropdown)
app.component('footer-component', FooterComponent)
app.component('plans', PlansComponent)
app.use(BootstrapVue3)
app.component('bureau-letter', BureauLetter)
app.component('creditor-letter', CreditorLetter)
app.component('public-record-letter', PublicRecordLetter)
app.component('creditor-inquiry-letter', CreditorInquiryLetter)
app.component('data-furnisher-letter', DataFurnisherLetter)
app.component('lexis-nexis-letter', LexisNexisLetter)
app.component('cra-ftc-complaint-letter', CraFtcComplaint)
app.component('inquiry-letter', InquiryLetter)
app.component('lexis-nexis-security-freeze', LexisNexisSecurityFreeze)
app.component('account-resolution-services-security-freeze', AccountResolutionServicesSecurityFreeze)
app.component('corelogic-credco-security-freeze', CorelogicCredcoSecurityFreeze)
app.component('cra-student-loan-dispute', CraStudentLoanDispute)
app.component('creditor-student-loan-dispute', CreditorStudentLoanDispute)
app.component('sagestream-security-freeze', SagestreamSecurityFreeze)
app.component('sagestream-request-for-disclosure', SagestreamRequestForDisclosure)
app.component('sagestream-request-an-investigation', SagestreamRequestAnInvestigation)
app.component('opt-out-pre-screen', OptOutPreScreen)
app.component('nctue-security-freeze', NctueSecurityFreeze)
app.component('factor-trust-security-freeze', FactorTrustSecurityFreeze)
app.component('chexsystem-security-freeze', ChexsystemSecurityFreeze)
app.component('innovis-security-freeze', InnovisSecurityFreeze)
app.component('cra-initial-dispute', CraInitialDispute)
app.component('initial-validation-dispute', InitialValidationDispute)
app.component('initial-verification-dispute', InitialVerificationDispute)
app.component('collection-agency-computer-response', CollectionAgencyComputerResponse)
app.component('collection-agency-itemized-list-response', CollectionAgencyItemizedListResponse)
app.component('collection-agency-more-information-response', CollectionAgencyMoreInformationResponse)
app.component('collection-agency-no-response', CollectionAgencyNoResponse)
app.component('creditor-no-response', CreditorNoResponse)
app.component('creditor-partial-verification-response', CreditorPartialVerificationResponse)
app.component('creditor-more-information-response', CreditorMoreInformationResponse)
app.component('cra-method-of-verification-response', CraMethodOfVerificationResponse)
app.component('cra-no-response', CraNoResponse)
app.component('cra-collection-agency-failed-to-validate-response', CraCollectionAgencyFailedToValidateResponse)
app.component('factual-dispute-letter', FactualDisputeLetter)
app.component('metro-2-letter-1', Metro2Letter1)
app.component('metro-2-letter-2', Metro2Letter2)
app.component('metro-2-letter-3', Metro2Letter3)
app.component('collection-agency-estoppel-by-silence', CollectionAgencyEstoppelBySilence)
app.component('creditor-still-no-response', CreditorStillNoResponse)
app.component('creditor-partial-verification-response-2', CreditorPartialVerificationResponse2)
app.component('debt-verified-response', DebtVerifiedResponse)
app.component('creditor-notice-of-complaint', CreditorNoticeOfComplaint)
app.component('ca-notice-of-complaint', CaNoticeOfComplaint)
app.component('cra-notice-of-complaint', CraNoticeOfComplaint)
app.component('cra-late-payment-dispute', CraLatePaymentDispute)
app.component('creditor-late-payment-dispute', CreditorLatePaymentDispute)
app.component('cease-desist-letter', CeaseDesistLetter)
app.component('debt-validation-letter', DebtValidationLetter)
app.component('affidavit-of-truth-letter', AffidavitOfTruthLetter)
app.component('creditor-ftc-complaint', CreditorFtcComplaint)
app.component('ca-ftc-complaint', CaFtcComplaint)
app.component('request-for-verification-round-1', RequestForVerificationRound1)
app.component('request-for-verification-round-2', RequestForVerificationRound2)
app.component('request-for-verification-round-3', RequestForVerificationRound3)
app.component('demand-for-removal-letter', DemandForRemovalLetter)
app.component('reinsertion-dispute-letter', ReinsertionDisputeLetter)
app.component('request-to-remove-fraud-alert', RequestToRemoveFraudAlert)
app.component('method-to-verification-letter', MethodOfVerificationLetter)
app.component('notification-of-lawsuit-letter', NotificationOfLawsuitLetter)
app.component('failure-to-respond-within-15-days', FailureToRespondWithin15Days)
app.component('failure-to-respond-within-30-days', FailureToRespondWithin30Days)
app.component('failed-to-mark-notice-of-dispute', FailedToMarkNoticeOfDispute)
app.component('tall-letter-response', StallLetterResponse)
app.component('requesting-the-removal-of-inaccurate-information', RequestingTheRemovalOfInaccurateInformation)
app.component('requesting-the-removal-of-inaccurate-accounts-round2', RequestingTheRemovalOfInaccurateAccountsRound2)
app.component('requesting-the-removal-of-inaccurate-accounts-round3',RequestingTheRemovalOfInaccurateAccountsRound3)
app.component('intent-to-file-suit-violation-of-the-fcra', IntentToFileSuitViolationOfTheFcra)
app.component('collection-dispute-letter-1-b',CollectionDisputeLetter1B)
app.component('collection-dispute-letter-2',CollectionDisputeLetter2)
app.component('collection-dispute-letter-3', CollectionDisputeLetter3)
app.component('collection-dispute-letter-4', CollectionDisputeLetter4)
app.component('late-payment-dispute-letter-1', LatePaymentDisputeLetter1)
app.component('late-payment-dispute-letter-2', LatePaymentDisputeLetter2)
app.component('late-payment-dispute-letter-3', LatePaymentDisputeLetter3)
app.component('late-payment-dispute-letter-4', LatePaymentDisputeLetter4)
app.component('repossession-letter-1', RepossessionLetter1)



app.component('lob-letter', LobLetter)
app.component('authorized-user', AuthorizedUser)
app.component('authorized-user-checkout', AuthorizedUserCheckout)
app.component('cra-bankruptcy-validation-letter', CraBankruptcyValidationLetter)
app.component('cra-bankruptcy-response-letter', CraBankruptcyResponseLetter)
app.component('cra-bankruptcy-metro-2-letter', CraBankruptcyMetro2Letter)
app.component('lexisnexis-bankruptcy-validation-letter', LexisnexisBankruptcyValidationLetter)
app.component('lexisnexis-bankruptcy-response-letter', LexisnexisBankruptcyResponseLetter)
app.component('lexisnexis-credit-freeze-request', LexisnexisCreditFreezeRequest)
app.component('custom-letter', CustomLetter)
app.component('creditor-car-repossession-letter-1', CreditorCarRepossessionLetter1)
app.component('creditor-car-repossession-letter-2', CreditorCarRepossessionLetter2)
app.component('medical-collection-law-letter', MedicalCollectionLawLetter)
app.component('courthouse-letter', CourthouseLetter)
app.component('credit-bureau-medical-letter', CreditBureauMedicalLetter)
app.component('demand-to-comply-law-letter', DemandToComplyLawLetter)
app.component('permissble-purpose-law-letter', PermissblePurposeLawLetter)
app.component('letter-edit', LetterEdit)
app.component('author-blog-component', AuthorBlogComponent)
app.component('blog-component', BlogComponent)
app.component('create-component', CreateComponent)
app.component('blog-content-component', BlogContentComponent)
app.component('blog-edit-component', BlogEditComponent)
app.component('credit-scores',CreditScores)
app.component('spinner', SpinnerComponent)
app.component('admin-dashboard',AdminDashboard)
app.component('admin-user-view',AdminUserView)
app.component('index-component',IndexComponent)
app.component('business-user-account',BusinessUserAccount)
app.component('custom-letter-create', CustomLetterCreateComponent)
app.component('otp-verify-component', OtpVerifyComponent)
app.component('add-phone-component', AddPhoneComponent)
app.component('report-summary', ReportSummaryComponent)
app.component('account-history', AccountHistoryComponent)
app.component('payment-history', PaymentHistoryComponent)
app.component('deleted-account-detail', DeletedAccountDetailComponent)
app.component('derogatory', DerogatoryComponent)
app.component('late-payment', LatePaymentComponent)
app.component('inquiry', InquiryComponent)
app.component('public-record', PublicRecordComponent)
app.component('report', ReportComponent)
app.component('credit-analysis', CreditAnalysis)
app.component('account-detail-modal', AccountDetailModalComponent)
app.component('credit-monitoring', CreditMonitoring)
app.component('attack-history', AttackHistoryComponent)
app.component('dispute-report', DisputeReportComponent)
app.component('identity-iq', IdentityIQComponent)
app.component('email', EmailComponent)
app.component('fax-history', FaxHistory)
app.component('Timeline', TimelineComponent)
app.component('email-history', EmailHistory)
app.component('filter-component', FilterComponent)
app.component('order-history', OrderHistory)
app.component('admin-order-history', AdminOrderHistory)
app.component('billing-component', BillingComponent)
app.component('family-dashboard', FamilyDashboard)
app.component('diy-dashboard-component', DiyDashboardHeader)
app.component('business-header', BusinessHeader)
app.component('team-header', TeamHeader)
app.component('view-letter-content', ViewLetterContentComponent)
app.component('create-letter-content', CreateLetterContentComponent)
app.component('edit-letter-content', EditLetterContentComponent)
app.component('index-letter-content', IndexLetterContentComponent)
app.component('index-dashboard',IndexDashboard)
app.component('knowledge-base',KnowledgeBaseComponent)
app.component('knowledge-base-videos',KnowledgeBaseVideo)
app.component('create-knowledge-base-videos',CreateKnowledgeBaseVideos)
app.component('create-category-knowledge-base',CreateCategoryKnowledgeBase)
app.component('certified-mail-modal',CertifiedMailerModal)
app.component('dispute-tracker',DisputeTrackerComponent)
app.component('invoice-index', InvoiceIndexComponent)
app.component('invoice-tab', InvoiceTabComponent)
app.component('import-client-modal', ImportClientModal)
app.component('lincence-state-id',LincenceStateId)
app.component('social-security-card-upload',SocialSecurityCardUpload)
app.component('address-verification-upload',AddressVerificationUpload)
app.component('personal-info-modal',PersonalInfoModal)
app.component('my-score-iq-report',MyScoreIQReport)
app.component('smart-credit-report',SmartCreditReport)
app.component('my-free-score-now-form',MyFreeScoreNowForm)
app.component('proof-identity-document',ProofIdentityDocument)
app.component('dispute-letter-tracker',DisputeLetterTracker)
app.component('credit-analysis-modal',CreditAnalysisModal)
app.component('lob-setting', LobSetting)
app.component('fax-setting', FaxSetting)
app.component('admin-setting', AdminSetting)
app.component('letter-video',LetterVideo)
app.component('letter-tutorial',LetterTutorial)
app.component('credit-contact-index', CreditContactIndexComponent)
app.component('credit-contact-tab', CreditContactTabComponent)
app.component('letter-document-upload-modal', LetterDocumentUpload)
app.component('ssn-modal', Ssn)
app.component('profile', Profile)
app.component('dispute-count', DisputeCount)
app.component('thirty-day-report', ThirtyDayReport)
app.component('client-detail', ClientDetail)
app.component('home-component',HomeComponent)
app.component('edit-pipeline-client',EditPipelineClient)
app.component('pipeline-activity',PipelineActivity)
app.component('dispute-activity',DisputeActivity)
app.component('drop-image-model', CropImageModel)

app.component('contract-info-component',ContractInfoComponent)

app.component('gohighlevel-component',GohighlevelComponent)
app.component('generate-gohighlevel-access-token',GenerateAccessToken)
app.component('client-report-form', ClientReportForm)
app.component('referrals-component', ReferralsComponent)
app.component('e-book-component', EbookComponent)
app.component('user-ebook-products', UserEbookProducts)
app.component('messages-component', MessagesComponent)
app.component('messages-model', MessagesModel)
app.component('video-player-model', VideoPlayerModel)
app.component('contract-download-component', ContractDownloadComponent)
app.component('data-furnisher-model', DataFurnisherModal)
app.component('navbar-component',NavbarComponent)
app.component('upload-id-theft-affidavit',UploadIdTheftAffidavit)
app.component('image-cropper-modal',ImageCropperModal)
app.component('star-rating',StarRating)
app.component('home-nav-component',HomeNavComponent)
app.component('power-of-attorney',ContractInfoComponent)


app.component(VueFeather.name, VueFeather);

app.component('pagination', Pagination);

app.mixin(titlemixin)

const router = createRouter(
    { // if you have a different baseurl pass it in createWebHistory('/creditrepair/public')
        history: createWebHistory(),
        routes: routes
    }
)

require('./@core/assets/fonts/feather/iconfont.css')
require('../css/base/plugins/forms/form-wizard.css')
require('../vendors/css/forms/wizard/bs-stepper.min.css')

import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css'
// require('./scripts/toastification.js')
// For form-wizard('@core/assets/fonts/feather/iconfont.css') // For form-wizard
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

app.component('RoleComponent',RoleComponent)
app.component('PermissionsComponent',PermissionsComponent)
app.use(router)
app.use(pinia)
app.use(Vue3VideoPlayer, {
    lang: 'en'
})
app.use(Vue3Signature)
router.isReady().then(() => {
    app.use(Vue3VideoPlayer, {
    lang: 'en'
  })
app.mount('#app')
})


// require('countries-and-timezones');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
// Vue.component('phone-input-component', require('./components/PhoneInputComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */



// const app = new Vue({
//     el: '#app',
// });
